import { PatientInfoValues } from '../enums/patient-info-values.enum';
import { PatientInfoGroups } from '../enums/patient-info-groups.enum';

export const PatientInfoValueGroup = {
  [PatientInfoValues.SPECIES]: PatientInfoGroups.PRIMARY,
  [PatientInfoValues.BREED]: PatientInfoGroups.PRIMARY,
  [PatientInfoValues.WEIGHT]: PatientInfoGroups.SECONDARY,
  [PatientInfoValues.BIRTH_DATE]: PatientInfoGroups.SECONDARY,
  [PatientInfoValues.GENDER]: PatientInfoGroups.SECONDARY,
  [PatientInfoValues.OWNER_NAME]: PatientInfoGroups.CONTACT,
  [PatientInfoValues.OWNER_EMAIL]: PatientInfoGroups.CONTACT,
  [PatientInfoValues.OWNER_PHONE_NUMBER]: PatientInfoGroups.CONTACT
};
